import { ListItemButton } from '@mui/material'
import { ReactNode } from 'react'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'

export type ListItemButtonWithNavigationProps = {
  path: string
  activePaths?: readonly string[]
  onNavigate?: () => void
  children: ReactNode
}

const ListItemButtonWithNavigation = ({
  path,
  activePaths,
  onNavigate,
  children,
}: ListItemButtonWithNavigationProps) => {
  const navigate = useNavigate()
  const location = useLocation()

  const paths = activePaths && activePaths.length > 0 ? [path, ...activePaths] : [path]
  const isActive = paths.some((candidate) =>
    matchPath(
      {
        path: candidate,
        end: false,
      },
      location.pathname
    )
  )

  return (
    <ListItemButton
      component="button"
      type="button"
      onClick={(event) => {
        event.preventDefault()
        navigate(path)
        onNavigate?.()
      }}
      selected={!!isActive}
    >
      {children}
    </ListItemButton>
  )
}

export default ListItemButtonWithNavigation
